import React from "react";
import CollectionImage1 from "../../assets/CollectionImage1.avif";
import CollectionImage2 from "../../assets/CollectionImage2.avif";
import CollectionImage3 from "../../assets/CollectionImage3.avif";
import CollectionImage4 from "../../assets/CollectionImage4.avif";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import "./Collection.css";

const Collection = () => {
  return (
    <div className="collection flex column">
      <h2 className="collectionHeading">Collections</h2>
      <div className="collectionText flex">
        <h6 className="collectionTextSubHeading">
          Explore curated lists of top restaurants, cafes, pubs, and bars in
          Bhubaneswar, based on trends
        </h6>
        <span className="collectionTextLocation flex cursorPointer">
          All collections in Bhubaneswar <ArrowRightIcon />
        </span>
      </div>
      <div className="collectionCard grid">
        <div className="collectionCardImage cursorPointer">
          <img src={CollectionImage1} alt="Live Sports Screenings" />
          <p>Live Sports Screenings</p>
          <h6>
            12 Places <ArrowRightIcon />
          </h6>
        </div>
        <div className="collectionCardImage cursorPointer">
          <img src={CollectionImage2} alt="Rooftops" />
          <p>Rooftops</p>
          <h6>
            5 Places <ArrowRightIcon />
          </h6>
        </div>
        <div className="collectionCardImage cursorPointer">
          <img src={CollectionImage3} alt="Pocket Friendly" />
          <p>Pocket Friendly</p>
          <h6>
            6 Places <ArrowRightIcon />
          </h6>
        </div>
        <div className="collectionCardImage cursorPointer">
          <img src={CollectionImage4} alt="Taste Of Odisha" />
          <p>Taste Of Odisha</p>
          <h6>
            7 Places <ArrowRightIcon />
          </h6>
        </div>
      </div>
    </div>
  );
};

export default Collection;
